export const AUTH_LOADING_STATE = {
  AUTHENTICATION_LOADING: 'AUTHENTICATION_LOADING' as const,
  FETCH_ME: 'FETCH_ME' as const,
  RESET_PASSWORD_LOADING: 'RESET_PASSWORD_LOADING' as const,
  CONFIRM_PASSWORD_RESET_LOADING: 'CONFIRM_PASSWORD_RESET_LOADING' as const,
};
